module.exports = __webpack_public_path__ + "static/media/dude.906ef5aa.jpg";